import PublishedPollTitle, { PublishedPollTitleProps } from './PublishedPollTitle';
import UnpublishedPollTitle, { UnpublishedPollTitleProps } from './UnpublishedPollTitle';
import usePollTitle from './vm';

export interface PollTitleProps extends UnpublishedPollTitleProps, PublishedPollTitleProps {}

const PollTitle = ({ formMethods, onSubmit, onLocalSubmit, className }: PollTitleProps) => {
  const { isPollPublished, isPresenting } = usePollTitle();

  if (isPollPublished || isPresenting) {
    return <PublishedPollTitle className={className} />;
  }

  return (
    <UnpublishedPollTitle
      formMethods={formMethods}
      onSubmit={onSubmit}
      onLocalSubmit={onLocalSubmit}
      className={className}
    />
  );
};

export default PollTitle;
